import React from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';
import PropTypes from 'prop-types';

import { useDirection } from '../../../../hooks';
import { deprecated } from '../../../../internal/propTypeValidators';
import sx from '../../../../internal/styles/sx';
import { BaseFlex } from '../../../../layouts/Flex/Flex';

export const LabelContainer = styled(BaseFlex)(({ icon, image, isRtl }) =>
  css({
    position: 'absolute',
    width: '100%',
    pl: icon || isRtl ? 'input.icon' : image || isRtl ? 8 : 2,
    pr: icon || !isRtl ? 'input.icon' : image || !isRtl ? 8 : 2,
    pointerEvents: 'none',
  })
);

export const StyledInnerLabel = styled('label', { shouldForwardProp })(
  ({ disabled, negative, focus, shrink, isRtl, invalid, isEmpty }) => {
    let type = 'default';

    if (negative === undefined) {
      negative = invalid;
    }

    if (shrink === undefined) {
      shrink = focus || !isEmpty;
    }

    if (disabled) {
      type = 'disabled';
    } else if (negative && !focus) {
      type = 'negative';
    } else if (focus) {
      type = 'branded';
    }

    return css({
      display: 'flex',
      position: 'absolute',
      width: '100%',
      pointerEvents: 'none',
      cursor: disabled ? 'default' : 'text',
      userSelect: 'none',
      left: !isRtl ? 0 : 'auto',
      right: isRtl ? 0 : 'auto',
      px: 'small',
      fontFamily: 'body',
      fontSize: `input.${shrink ? 'shrink' : 'label'}`,
      color: `input.${type}.label`,
      transformOrigin: !isRtl ? 'top left' : 'top right',
      transform: `translateY(${shrink ? '50' : '105'}%)`,
      transition: 'transform 200ms, font-size 200ms',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'pre',
      zIndex: 2,
    });
  },
  sx
);

const InnerLabel = (props) => {
  const isRtl = useDirection();
  return <StyledInnerLabel {...props} isRtl={isRtl} />;
};
InnerLabel.isInnerLabel = true;

InnerLabel.propTypes = {
  shrink: PropTypes.bool,
  focus: PropTypes.bool,
  negative: deprecated(PropTypes.bool),
  invalid: PropTypes.bool,
  disabled: PropTypes.bool,
  icon: PropTypes.element,
  image: PropTypes.bool,
};

export default InnerLabel;
